<template>
  <div>
    <div class="featurex">
      <slot name="topBtn"></slot>
      <span class="featurex1" @click="drawerBtn"
        ><img src="@/assets/img/icon_sx.svg" />筛选</span
      >
    </div>
    <ul>
      <li v-for="(el, index) in tableData" :key="index">
        <slot v-bind:data="el"></slot>
      </li>
    </ul>
    <div>
      <el-pagination
        v-if="total > 20"
        background
        class="sel-pagin"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="limit"
        :page-sizes="[20, 50, 100, 200, 500, 1000, 2000]"
        layout="prev, pager, next, sizes,jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <el-drawer
      title="筛选项"
      class="drawer-box"
      :visible.sync="drawer"
      :before-close="handleClose"
    >
      <el-form
        :label-position="'top'"
        v-if="config.filterForm"
        :model="form"
        ref="form"
      >
        <el-form-item
          v-for="(item, index) in config.filterForm"
          :key="index"
          :label="item.label"
          :prop="item.prop"
        >
          <el-input
            v-if="item.type === 'text'"
            v-model="form[item.prop]"
            autocomplete="off"
            :placeholder="item.pl"
          ></el-input>
          <el-select
            v-if="item.type === 'select'"
            v-model="form[item.prop]"
            :placeholder="item.pl"
          >
            <el-option
              v-for="(items, indexs) in item.option"
              :key="indexs"
              :label="items.label"
              :value="items.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div class="drawer-footer">
        <el-button @click="resetForm">重 置</el-button>
        <el-button type="primary" @click="confirmFn">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
export default {
  props: {
    config: Object,
  },
  data() {
    return {
      form: {},
      drawer: false,
      loading: false,
      page: 1,
      limit: 20,
      total: 0,
      tableData: [],
    };
  },
  mounted() {
    this.getData();
  },
  watch: {
    selectedData() {
      this.$emit("selectedDatafn", this.selectedData);
    },
  },
  methods: {
    handleClose() {
      this.drawer = false;
    },
    resetForm() {
      this.form = {};
    },
    drawerBtn() {
      this.drawer = true;
    },
    confirmFn() {
      this.handleClose();
      this.getData(this.form);
    },
    getData(obj) {
      if (this.loading) {
        this.$message("正在处理请稍后");
        return;
      }
      let pr = {
        page: this.page,
        limit: this.limit,
      };
      if (this.config.pr) {
        pr = Object.assign(this.config.pr, pr);
      }

      if (obj) {
        pr = Object.assign(obj, pr);
      }
      if (this.config.getUrlPr) {
        pr = Object.assign(this.config.getUrlPr(), pr);
      }
      this.loading = true;

      this.api[this.config.url](pr)
        .then((da) => {
          this.loading = false;
          if (da == "error") {
            return;
          }
          this.total = da.total;
          this.tableData = da.data;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.limit = val;
      this.handleCurrentChange(1);
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getData();
    },
  },
};
</script>
<style >
.featurex {
  position: relative;
  height: 30px;
  margin-bottom: 20px;
}
.featurex1 {
  position: absolute;
  right: 10px;
  top: 0;
  cursor: pointer;
}
</style>

